'use client'

import { ModelsNews } from '@/api/generated-api'
import { Link } from '@/i18n/routing'
import Image from '@/ui/MediaImage'

import { formatNewsRelativeTime, getNewsDisplayDate } from '../../utils/date'
import { getPrimaryNewsTagLabel } from '../../utils/newsTags'
import NewsCategoryBadge from './NewsCategoryBadge'
import S from './NewsHeroFeatured.module.scss'

type NewsHeroMainCardProps = {
  news: ModelsNews
  locale: string
}

const NewsHeroMainCard = ({ news, locale }: NewsHeroMainCardProps) => {
  const tagLabel = getPrimaryNewsTagLabel(news)
  const timeLabel = formatNewsRelativeTime(getNewsDisplayDate(news), locale)

  return (
    <Link href={`/news/${news.id}`} className={S.mainCard}>
      <div className={S.mainImage}>
        {news.header_image_url && (
          <Image
            src={news.header_image_url}
            alt={news.title || 'News image'}
            fill
            className={S.mainImageContent}
            sizes="(max-width: 768px) 100vw, 796px"
            priority
          />
        )}
      </div>
      <div className={S.mainContent}>
        <div className={S.metaRow}>
          {tagLabel && <NewsCategoryBadge label={tagLabel} />}
          {timeLabel && <span className={S.time}>{timeLabel}</span>}
        </div>
        <h2 className={S.mainTitle}>{news.title}</h2>
      </div>
    </Link>
  )
}

export default NewsHeroMainCard
